// Reconstructed from the supplied production build; original component names were unavailable.
import { axios } from "../vendor/runtime.js";
import { API_BASE_URL } from "../config.js";
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});
api.interceptors.response.use(
  (a) => a,
  (a) => (a.response && a.response.status, Promise.reject(a)),
);
export { api };
